import React, { useEffect } from "react";

const CollectPaymentForm = () => {
  useEffect(() => {
    if (window.CollectJS && window.CollectJS.configure) {
      setupCollect();
    } else if (!document.getElementById("collectjs-script")) {
      const script = document.createElement("script");
      script.id = "collectjs-script";
      script.src = "https://secure.nmi.com/token/Collect.js";
      script.dataset.tokenizationKey = "S3xqzC-A29h4E-vhfc7b-2uP5Xz";
      script.onload = setupCollect;
      document.body.appendChild(script);
    }

    function setupCollect() {
      if (!window.CollectJS) return;

      window.CollectJS.configure({
        paymentSelector: "#demoPayButton",
        variant: "inline",
        fields: {
          ccnumber: {
            selector: "#demoCcnumber",
            title: "Card Number",
            placeholder: "0000 0000 0000 0000",
          },
          ccexp: {
            selector: "#demoCcexp",
            title: "Card Expiration",
            placeholder: "00 / 00",
          },
          cvv: {
            display: "show",
            selector: "#demoCvv",
            title: "CVV",
            placeholder: "123",
          },
        },
        callback: async function (response) {
          if (!response.token) {
            alert("Something went wrong. Please try again.");
            return;
          }

          console.log("Token generated:", response.token);

          // 📌 Send token to backend to charge card
          try {
            const res = await fetch("https://booktrip4me.com/api/payment.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                token: response.token,
                amount: 100,   // Replace with actual total
              }),
            });

            const data = await res.json();

            if (data.success) {
              window.location.href = "/payment-success.html";
            } else {
              window.location.href = "/payment-failure.html";
            }
          } catch (error) {
            console.error("Charge error:", error);
            window.location.href = "/payment-failure";
          }
        },
      });
    }
  }, []);

  return (
    <div className="max-w-md mx-auto p-4 bg-white rounded-lg shadow">
      <h1 className="text-xl font-semibold text-center mb-4">
        Secure Payment
      </h1>

      <form>
        <div className="mb-4">
          <label className="block mb-1">Card Number</label>
          <div id="demoCcnumber" className="border rounded p-2 h-10" />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Expiration Date</label>
          <div id="demoCcexp" className="border rounded p-2 h-10" />
        </div>

        <div className="mb-4">
          <label className="block mb-1">CVV</label>
          <div id="demoCvv" className="border rounded p-2 h-10" />
        </div>

        <button
          id="demoPayButton"
          type="button"
          className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Pay Now
        </button>
      </form>
    </div>
  );
};

export default CollectPaymentForm;
